var app = angular.module('leonardo');

var WidgetFieldSubGroupAutocomplete = function(scope) {
  scope.autocomplete = {
    search: '',
    options: [],
    enabled: [],
    onFocus: false
  };

  scope.refresh = function() {
    scope.autocomplete.options = [];
    scope.autocomplete.enabled = [];
    angular.forEach(scope.subgroup.fields, function(field) {
      var item = {
        key: field.key,
        label: field.name
      };
      if (scope.field_data[field.key]) {
        scope.autocomplete.enabled.push(item);
      }
      else {
        scope.autocomplete.options.push(item);
      }
    });
  };

  scope.setOption = function(key) {
    scope.field_data[key] = true;
    scope.refresh();
  };
  scope.removeOption = function(key) {
    delete scope.field_data[key];
    scope.refresh();
  };
  scope.refresh();
};

var WidgetFieldSubGroup = function(deviceDetector, $filter, AuthService) {
  return {
    restrict: 'A',
    templateUrl: 'views/templates/widget/field/subgroup.html',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      type: '@widgetFieldSubgroup',
      subgroup: '=',
      field_data: '=fieldData',
      mode: '@',
      action: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.isEdge = _.contains(['ms-edge', 'ie'], deviceDetector.browser);
      scope.is_super_admin = AuthService.hasOldToken();
      scope.ngModelCtrl.$validators.required = function(modelValue, viewValue) {
        if ((scope.mode === 'property') && ((!scope.subgroup.data.property_required) || (scope.subgroup.data.property_widget === 'hidden'))) {
          return true;
        }
        if ((scope.mode === 'template') && ((!scope.subgroup.data.template_required) || (scope.subgroup.data.template_widget === 'hidden'))) {
          return true;
        }
        var any = false;
        angular.forEach(scope.subgroup.fields, function(field) {
          if (scope.field_data[field.key]) {
            any = true;
          }
        });
        return any;
      };

      if (scope.mode === 'property' && scope.action === 'create') {
        angular.forEach(scope.subgroup.fields, function(field) {
          if (field.type === 'bool') {
            scope.field_data[field.key] = field.data.default_value ? true : false;
          }
          else if (field.type === 'integer') {
            if (!isNull(field.data.default_value)) {
              scope.field_data[field.key] = !isNaN(field.data.default_value) ?
                Number(field.data.default_value) : undefined;
            }
            else {
              scope.field_data[field.key] = undefined;
            }
          }
          else {
            scope.field_data[field.key] = field.data.default_value;
          }
        });
      }

      scope.$watch('field_data', function() {
        scope.ngModelCtrl.$validate();
      }, true);

      if (scope.type === 'autocomplete') {
        WidgetFieldSubGroupAutocomplete(scope);
      }

      scope.getHeightFlex = function(subgroup) {
        var do_it = false;
        if (scope.isEdge) {
          return null;
        }
        if (subgroup.fields.length > 5) {
          angular.forEach(subgroup.fields, function(value){
            if (value.type === 'bool') {
              do_it = true;
            }
          });
          if (do_it){
            var all_bool = true;
            angular.forEach(subgroup.fields, function(value){
              if (value.type !== 'bool') {
                all_bool = false;
              }
            });
            if (!all_bool) {
              var mod = ~~(subgroup.fields.length / 4);
              if ( (subgroup.fields.length / 4) == mod ) {
                return {height: (mod * 100)};
              }
              else {
                return {height: (mod * 100) + 100};
              }
            }
            else {
              var mod1 = ~~(subgroup.fields.length / 5);
              if ( (subgroup.fields.length / 5) == mod1 ) {
                return {height: (mod1 * 60)};
              }
              else {
                return {height: (mod1 * 60) + 60};
              }
            }
          }
          else {
            return null;
          }
        }
        else {
          return null;
        }
      };

      scope.getClassFlex = function(subgroup) {
        var classes = [];
        if (scope.isEdge) {
          return classes;
        }
        var do_it = false;
        if (subgroup.fields.length > 5) {
          angular.forEach(subgroup.fields, function(value){
            if (value.type === 'bool') {
              do_it = true;
            }
          });
          if (do_it) {
            classes.push('flex');
          }
        }
        return classes;
      };
    }
  };
};

app.directive('widgetFieldSubgroup', ['deviceDetector', '$filter', 'AuthService', WidgetFieldSubGroup]);
